/**
 * PilotDial component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled pilot dial.
 */
const DialInput = styled.span`
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${80 * Screen.widthRatio}px;
  left: ${124 * Screen.widthRatio}px;
  justify-content: start;
  position: absolute;
  top: ${56 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(DialInput);
